import { render, staticRenderFns } from "./assignVendorModule.vue?vue&type=template&id=82944be0&"
import script from "./assignVendorModule.vue?vue&type=script&lang=js&"
export * from "./assignVendorModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports